import React, { PropsWithChildren, forwardRef } from "react";

/*
This link is used as a default component on site context
*/
export const FrameWorkAgnosticLink = forwardRef<
  HTMLAnchorElement,
  PropsWithChildren<React.AnchorHTMLAttributes<HTMLAnchorElement>>
>(function InnerFrameworkAgnosticLink(props, ref) {
  return (
    <a ref={ref} {...props}>
      {props.children}
    </a>
  );
});

export const mockLogNavigate = (to: string) =>
  console.log(`Navigating to ${to}`);
